export { default } from '@made-people/centra-storyblok-nuxt-shared/lib/store/ui'
